var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 1H1M17 7H6M17 13H1",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgMenu;